import { render, staticRenderFns } from "./CustomFieldFormPage.vue?vue&type=template&id=9f283e08&"
import script from "./CustomFieldFormPage.vue?vue&type=script&lang=js&"
export * from "./CustomFieldFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports